export const listReport = {
  table: {
    date: '日付',
    total: '合計',
    reset: 'リセット',
    export: 'エクスポート',
    hour: '(単位　ｈ)',
    id: '履歴ID',
    addTag: '追加タブ',
    customerId: '顧客ID',
    customerCode: '納入先CD',
    customerName: '顧客名',
    operatorCode: 'オペレーターコード',
    operatorName: '担当者',
    washingMachineId: '洗濯機ID',
    washingMachineCode: '水洗機NO',
    washingMachineName: '水洗機表記名',
    washingMethodName: '洗濯方法',
    startDateTime: '開始時刻',
    endDateTime: '終了時刻',
    duration: '所要時間（分）',
    washingTime: '洗浄時間',
    washingMethod: '洗浄プログラム',
    laundryWeight: '洗浄量/%',
    detergentCost: '洗剤費/1w',
    hydroKleanUsedPerGram: 'HK/g',
    rinseWaterPerMl: '過水/ml',
    volumes: '容量（L）',
    totalPrice: '合計金額',
    detergents: '洗剤',
    totalWaterUsed: '使用水量/l',
    totalUsage: '合計使用量/ml',
    usagePerCapacity: '使用量/容量',
    amount: '金額/円',
    unitPrice: '単価',
    machineCode: '水洗機NO',
    water: '使用水量/l',
    action: 'アクション',
  },
  pageHeader: {
    title: '洗浄履歴',
  },
  filter: {
    filterDay: '洗浄回数管理 日別',
    filterByRangeDay: '顧客別管理',
    filterByTime: '洗濯回数管理 期間指定日別',
    filterCustomerName: '顧客名',
    filterOperator: '担当者',
    filterMachine: '水洗機',
  },
  modal: {
    title: '洗浄工程追加',
    washingMachine: '水洗機',
    customerName: '顧客名',
    operatorName: '担当者',
    washingMethod: '洗浄プログラム',
    volume: '洗浄量',
    time: '開始時間',
    submit: '新規追加',
    requireWashingMachine: '水洗機を入力してください',
    requireCustomerName: '顧客名を入力してください',
    requireOperatorName: '担当者を入力してください',
    requireWashingMethod: '洗浄プログラムを入力してください',
    requireVolume: '洗浄量を入力してください',
    requireTime: '開始時間を入力してください',
  },
  hooks: {
    selectRangeDateFail: '範囲の日付が無効です',
  },
}
